(() => {

  const translations = new Map([

    ['Cart', 'Sepet'],
    ['Your cart', 'Sepetiniz'],
    ['Shopping cart', 'Sepetiniz'],

    ['You may also like', 'Bunlar da ilginizi çekebilir'],
    ['You might also like', 'Bunlar da ilginizi çekebilir'],
    ['Related products', 'Benzer seçimler'],

    ['View all', 'Tümünü Gör'],
    ['View All', 'Tümünü Gör'],

    ['Join our email list', 'SoulByChi dünyasına katılın'],
    ['Join our mailing list', 'SoulByChi dünyasına katılın'],

    ['Email', 'E-posta'],
    ['Email address', 'E-posta adresiniz'],
    ['Enter your email', 'E-posta adresiniz'],

    ['Subscribe', 'Katıl'],
    ['Sign up', 'Katıl'],

    ['Sold out', 'Tükendi'],
    ['Sold Out', 'Tükendi'],

    ['Add to cart', 'Sepete Ekle'],
    ['Add to Cart', 'Sepete Ekle'],

    ['Buy it now', 'Hemen Satın Al'],
    ['Buy now', 'Hemen Satın Al'],

    ['Search', 'Ara'],
    ['Account', 'Hesabım'],

    ['Continue shopping', 'Alışverişe Devam Et'],
    ['Continue Shopping', 'Alışverişe Devam Et'],

    ['Your cart is empty', 'Sepetiniz boş'],
    ['Cart is empty', 'Sepetiniz boş'],

    ['Checkout', 'Ödemeye Geç'],
    ['Check out', 'Ödemeye Geç'],

    ['Subtotal', 'Ara Toplam'],

    ['Quantity', 'Adet'],

    ['Remove', 'Kaldır'],

    ['Close', 'Kapat'],

    ['Previous', 'Önceki'],
    ['Next', 'Sonraki'],

    ['Filter', 'Filtrele'],
    ['Filters', 'Filtreler'],

    ['Sort by', 'Sırala'],

    ['Availability', 'Stok durumu'],

    ['Price', 'Fiyat']

  ]);


  function clean(value) {

    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();

  }


  function translateTextNode(node) {

    if (!node?.nodeValue) {
      return;
    }


    const original =
      node.nodeValue;


    const cleaned =
      clean(original);


    if (!translations.has(cleaned)) {
      return;
    }


    const translated =
      translations.get(cleaned);


    /*
     * Baştaki ve sondaki boşlukları koru.
     */

    const leading =
      original.match(/^\s*/)?.[0] || '';


    const trailing =
      original.match(/\s*$/)?.[0] || '';


    node.nodeValue =
      leading +
      translated +
      trailing;

  }


  function translateAttributes(element) {

    if (!(element instanceof Element)) {
      return;
    }


    const attributes = [
      'placeholder',
      'aria-label',
      'title'
    ];


    attributes.forEach(attribute => {

      if (!element.hasAttribute(attribute)) {
        return;
      }


      const value =
        clean(
          element.getAttribute(attribute)
        );


      if (translations.has(value)) {

        element.setAttribute(
          attribute,
          translations.get(value)
        );

      }

    });


    /*
     * Input / button value
     */

    if (
      element instanceof HTMLInputElement &&
      element.value
    ) {

      const value =
        clean(element.value);


      if (translations.has(value)) {

        element.value =
          translations.get(value);

      }

    }

  }


  function translateRoot(root = document.body) {

    if (!root) {
      return;
    }


    /*
     * Root element attributes.
     */

    if (root instanceof Element) {
      translateAttributes(root);
    }


    /*
     * Bütün element attribute'ları.
     */

    root
      .querySelectorAll?.('*')
      .forEach(
        translateAttributes
      );


    /*
     * Görünen text node'ları.
     */

    const walker =
      document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {

            const parent =
              node.parentElement;


            if (!parent) {
              return NodeFilter.FILTER_REJECT;
            }


            if (
              parent.closest(
                'script, style, noscript, textarea'
              )
            ) {
              return NodeFilter.FILTER_REJECT;
            }


            return NodeFilter.FILTER_ACCEPT;

          }
        }
      );


    const nodes = [];


    while (walker.nextNode()) {
      nodes.push(
        walker.currentNode
      );
    }


    nodes.forEach(
      translateTextNode
    );

  }


  function init() {

    translateRoot(
      document.body
    );


    /*
     * Shopify section render,
     * cart drawer ve AJAX içeriklerinde
     * sonradan gelen İngilizce metinleri de çevir.
     */

    let timer = null;


    const observer =
      new MutationObserver(
        mutations => {

          clearTimeout(timer);


          timer =
            setTimeout(
              () => {

                mutations.forEach(
                  mutation => {

                    mutation
                      .addedNodes
                      .forEach(
                        node => {

                          if (
                            node.nodeType ===
                            Node.TEXT_NODE
                          ) {

                            translateTextNode(node);

                          }


                          if (
                            node.nodeType ===
                            Node.ELEMENT_NODE
                          ) {

                            translateRoot(node);

                          }

                        }
                      );

                  }
                );

              },
              40
            );

        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true
      }
    );

  } else {

    init();

  }

})();